const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/", "/privacyPolicy"],
    exact: true,
    component: "Privacy",
  },
  {
    path: ["/", "/termsAndCondition"],
    exact: true,
    component: "Terms",
  },
];
  
export default routes;
